// extracted by mini-css-extract-plugin
export default {"DashboardDataNotFound":"DashboardDataNotFound_DashboardDataNotFound__MIu0L","DashboardDataNotFoundAdditionalText":"DashboardDataNotFound_DashboardDataNotFoundAdditionalText__N1wKt"};